module.exports = __webpack_public_path__ + "static/Dentures smile before-6c2f97e26803b162fb48a30311a8255b.jpg";